module.exports = __webpack_public_path__ + "static/img/修饰合成.3c587fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/一级标题Banner/修饰合成.jpg
// module id = 6+KL
// module chunks = 1